// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationsPage_container__3OyVf","subPage":"NotificationsPage_subPage__1icMb","bottomNavigation":"NotificationsPage_bottomNavigation__3MMLG"};